module.exports = __webpack_public_path__ + "static/media/404.b8be1f56.png";